import script from "./DeleteConfirmationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteConfirmationModal.vue?vue&type=script&setup=true&lang=js"

import "./DeleteConfirmationModal.vue?vue&type=style&index=0&id=c70647d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c70647d4"]])

export default __exports__